// extracted by mini-css-extract-plugin
module.exports = {"container":"latestPosts_container__OIg8V"};